import React from "react";
import { useHistory } from "react-router";
import ModuleHeader from "../modules/ModuleHeader";
import { useClearCurrentTopic } from "../../hooks/useClearCurrentTopic";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { selectIsSectionFinished } from "../../store/selectors";
import { Link } from "react-router-dom";
import { userSetsSectionThunk } from "../../store/thunks";
import { toggleBadgeModal } from "../../store/actions";
import { trackAdobeClick } from "../../utils/adobeLogging";

const linkClass = "text-blue-400 hover:text-blue-600 cursor-pointer mt-3";

const DonePage = () => {
  const history = useHistory();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  useClearCurrentTopic();

  const section = useSelector((state) => state.progress.section);
  const finished = useSelector((state) =>
    selectIsSectionFinished(state, section)
  );
  const progress = useSelector((state) => state.progress);
  const lang = useSelector((state) => state.ui.lang);

  if (!finished) {
    history.push("/app");
    return null;
  }
  const sectionName = section === "PMAgile" ? "Agile" : "Waterfall";

  const toggleSection = async (e) => {
    e.preventDefault();
    const nextSection = section === "PMAgile" ? "PMWaterfall" : "PMAgile";
    await dispatch(userSetsSectionThunk(nextSection));
    const name = nextSection === "PMAgile" ? "agile" : "waterfall";

    trackAdobeClick(null, {
      linkTitle: t(`done${sectionName}4`),
      linkModule: `${section}-congratulations-page`,
      targetURL: progress.currentPosition[lang][name + "Path"],
    });

    return history.push(progress.currentPosition[lang][name + "Path"]);
  };

  return (
    <div adoberegion={`${section}-congratulations-page`}>
      <ModuleHeader title={t(`done${sectionName}Header`)} />

      <div className="lg:px-0 px-3">
        <div className="bg-white shadow rounded py-10 px-10 min-h-screen">
          <div>
            <strong className="block mb-10">
              {t(`done${sectionName}Header`)}
            </strong>
          </div>

          <div className="mb-10">{t(`done${sectionName}Description`)}</div>

          <div className="mb-10">{t(`done${sectionName}ListHeader`)}</div>

          <ol>
            <li>
              <a
                className={linkClass}
                onClick={(e) => {
                  e.preventDefault();
                  dispatch(toggleBadgeModal());
                }}
              >
                {t(`done${sectionName}1`)}
              </a>
            </li>

            <li>
              <Link
                className={linkClass}
                onClick={(e) => {
                  trackAdobeClick(null, {
                    linkTitle: t(`done${sectionName}2`),
                    linkModule: `${section}-congratulations-page`,
                    targetURL: "/app/tools-and-templates",
                  });
                }}
                to="/app/tools-and-templates"
              >
                {t(`done${sectionName}2`)}
              </Link>
            </li>

            <li>
              <Link
                className={linkClass}
                onClick={(e) => {
                  trackAdobeClick(null, {
                    linkTitle: t(`done${sectionName}3`),
                    linkModule: `${section}-congratulations-page`,
                    targetURL: "/app/pages/learn-more",
                  });
                }}
                to="/app/pages/learn-more"
              >
                {t(`done${sectionName}3`)}
              </Link>
            </li>

            <li>
              <a href="#" className={linkClass} onClick={toggleSection}>
                {t(`done${sectionName}4`)}
              </a>
            </li>
          </ol>
        </div>
      </div>
    </div>
  );
};

export default DonePage;
